module.exports = __webpack_public_path__ + "media/images/dashcore/bg/gift-back-c4ff465227ac57c0ff88e472cc31b902.jpg";